import { useTranslation } from "react-i18next";
import { Sun, Moon, LogOut, Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUIStore } from "@/stores/ui";
import { useLogout, useReadiness, useMe } from "@/api/queries";
import { cn } from "@/lib/utils";

export function Topbar() {
  const { i18n } = useTranslation();
  const { theme, setTheme } = useUIStore();
  const { data: me } = useMe();
  const { data: readiness } = useReadiness();
  const logout = useLogout();

  const isDark =
    theme === "dark" ||
    (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);

  const allReady = readiness && Object.values(readiness.checks || {}).every(Boolean);

  return (
    <header className="flex h-16 items-center justify-between border-b border-border bg-card/50 px-6 backdrop-blur">
      <div className="flex items-center gap-3">
        <div
          className={cn(
            "flex h-2 w-2 rounded-full",
            allReady ? "bg-emerald-500 animate-pulse" : "bg-amber-500",
          )}
        />
        <span className="text-xs text-muted-foreground">
          {allReady ? "Готов" : "Деградация"}
        </span>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => i18n.changeLanguage(i18n.language === "en" ? "ru" : "en")}
          title="Сменить язык"
        >
          <Languages className="h-4 w-4" />
        </Button>

        <Button
          variant="ghost"
          size="icon"
          onClick={() => setTheme(isDark ? "light" : "dark")}
          title="Сменить тему"
        >
          {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>

        <div className="hidden text-right text-xs sm:block">
          <div className="font-medium">{me?.email || "-"}</div>
          <div className="text-muted-foreground">
            {me?.is_admin ? "Администратор" : "Пользователь"}
          </div>
        </div>

        <Button variant="ghost" size="icon" onClick={() => logout.mutate()} title="Выйти">
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
